// @vendors
//import React from 'react'
import { useTranslation } from 'react-i18next';

const MessagesPage = () => {
    const { t } = useTranslation();

    return (
        <div className='w-full lg:h-[400px]  h-[400px] flex items-center justify-center'>
            <p className='flex lg:text-[30px] text-[20px] text-gray-400 text-center pl-[20%] pr-[20%]'>
                {t("professional.messages.message")}
            </p>
        </div>
    )
}

export default MessagesPage